export default function (request, { urltemplate, server }) {
  const prefix = `${server.API_SERVER}/c`

  return {
    createCategory ({ body, params }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/products/categories`, params),
        method: 'post',
        data: body
      })
    },

    deleteCategory ({ params }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/products/categories/:categoryId`, params),
        method: 'delete'
      })
    },

    updateCategory ({ body, params }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/products/categories/:categoryId`, params),
        method: 'put',
        data: body
      })
    },

    getCategories ({ query, params }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/products/categories`, params),
        method: 'get',
        params: query
      })
    }

    // getArticleById ({ params }) {
    //   return request({
    //     url: urltemplate(`${prefix}/users/:userId/products/:productId`, params),
    //     method: 'get'
    //   })
    // }

  }
}
